import {Component, h} from 'preact';
import {formatPriceWithSymbol} from "../../tools";

import {
	Chart, registerables
} from 'chart.js';

class AccountDetailsChart extends Component {

	ref = null;
	setRef = (dom) => this.ref = dom;
	totalTitle = 'К оплате';

	defaultColors = {
		value: '#00B050',
		calc: '#FF6900',
		norm: '#4472C4',
		fine: '#ff0000',
	};


	constructor(props, context) {
		super(props, context);
		this.state = {
			details: props.details,
			total: props.amounts.total,
		}
	}

	componentDidMount() {
		const ctx = this.ref.getContext('2d');

		var labels = [];
		var colors = [];
		var data = [];

		for (let item of this.state.details) {
			labels.push(item.title);
			colors.push(this.defaultColors[item.method]);
			data.push(item.amount);
		}

		const options = {
			type: 'doughnut',
			data: {
				labels: labels,
				datasets: [{
					data: data,
					backgroundColor: colors,
					hoverOffset: 4
				}]
			},
			options: {
				responsive: false,
				plugins: {
					legend: {
						display: false
					},
				}
			},
		};

		Chart.register(...registerables);
		new Chart(ctx, options); // eslint-disable-line no-new
	}

	render(props, state, context) {
		let total = 550;
		return (
			<div className="details-chart">
				<canvas className="details-chart__chart" ref={this.setRef} />
				<div className="details-chart__total">
					<span className="details-chart__label">{this.totalTitle}</span>
					<span className="details-chart__value">{formatPriceWithSymbol(this.state.total)}</span>
				</div>
			</div>
		);
	}
}

export default AccountDetailsChart;